
import dayjs from "dayjs";
import { notification } from "ant-design-vue";
import relativeTime from "dayjs/plugin/relativeTime";
import { DeleteOutlined } from "@ant-design/icons-vue";
import { defineComponent, onMounted, ref } from "@vue/runtime-core";

import router from "@/router";
import { getFromStore } from "@/utils/store";
import Chip from "../components/Chip.vue";
import GoBack from "../components/Back.vue";
import Header from "../components/Header.vue";
import Loading from "../components/Loading.vue";
import ImageModal from "../components/Modal.vue";
import { toastError } from "../utils/toastError";
import { allergiesService } from "@/services/allergies";
import { IAllergyResponse, IComment } from "@/types/allergies";

dayjs.extend(relativeTime);

export default defineComponent({
  components: {
    Chip,
    GoBack,
    Header,
    Loading,
    ImageModal,
    DeleteOutlined,
  },
  setup() {
    const allergy = ref<IAllergyResponse>({
      name: "",
      severity: "",
      symptoms: [],
      image: "",
      highRisk: false,
      createdAt: new Date(),
      id: 0,
      comments: [],
      userId: 0,
    });

    const comment = ref("");
    const loading = ref(false);
    const seeMore = ref(false);
    const visible = ref(false);
    const currentUser = getFromStore("user");
    const paramId = router.currentRoute.value.params.id as string;

    const mapSeverity = ref<any>({
      Low: 25,
      Medium: 50,
      High: 75,
    });

    function getAllergy() {
      allergiesService
        .getAllergy(+paramId)
        .then((data) => (allergy.value = data))
        .catch((err) => {
          toastError(err);
          router.push("/dashboard");
        });
    }

    function addComment() {
      loading.value = true;
      if (comment.value) {
        allergiesService
          .addComment(comment.value, +paramId)
          .then(() => {
            comment.value = "";
            notification.success({ message: "Comment added!" });
            getAllergy();
          })
          .catch((err) => {
            toastError(err);
          })
          .finally(() => (loading.value = false));
      } else {
        loading.value = false;
        notification.warning({ message: "please add a valid comment!" });
      }
    }

    function deleteComment(commentData: Omit<IComment, "addedBy">) {
      const { comment, createdAt } = commentData;
      loading.value = true;
      allergiesService
        .deleteComment({ comment, createdAt }, +paramId)
        .then(() => {
          notification.error({ message: "Comment deleted!" });
          getAllergy();
        })
        .catch((err) => toastError(err))
        .finally(() => (loading.value = false));
    }

    const handleSee = () => (seeMore.value = !seeMore.value);

    const showModal = () => (visible.value = true);

    const handleOk = () => (visible.value = false);

    onMounted(() => getAllergy());

    return {
      paramId,
      allergy,
      comment,
      loading,
      mapSeverity,
      currentUser,
      dayjs,
      seeMore,
      visible,
      handleSee,
      getAllergy,
      addComment,
      deleteComment,
      handleOk,
      showModal,
    };
  },
});
